<template>
  <div v-if="!model.$disabled">
    <div v-bind:class="{'state-disabled': isDisabled, 'state-error': model.$error}" class="checkbox d-inline-block">
      <label class="checkbox" :labelFor="'checkbox-' + sid">
        <input
          :id="'checkbox-' + sid"
          ref="input"
          type="checkbox"
          value="true"
          role="checkbox"
          :checked="checked"
          :disabled="isDisabled"
          :name="model.$form.testPath ? model.$path : undefined"
          :aria-invalid="isError"
          :aria-describedby="`err-${sid} desc-${sid}`"
          :aria-checked="checked"
          @change="onInput($event)"
          @focus="onFocus($event)"
          @blur="onBlur($event)"
        />
        <i />

        <w-label
          style="display: inline-block;"
          cursor="pointer"
          :model="model"
          :title="title"
          :show-label="showLabel"
          :description="description"
          :is-html-title="isHtmlTitle"
          :next-number="nextNumber"
          :bold-label="boldLabel"
          :labelFor="'checkbox-' + sid"
          :only-description="onlyDescription"
        >
          <template v-slot:description>
            <slot name="description" />
          </template>
          <template v-slot:afterLabel>
            <slot name="afterLabel" />
          </template>
        </w-label>
      </label>

      <w-error :model="model" v-if="showError" :id="'err-' + sid" />
    </div>
  </div>
</template>

<script>
import modelMixin from '../mixins/modelMixin';
import titleMixin from '../mixins/titleMixin';

import WError from './error.vue';
import WTooltip from './tooltip.vue';

export default {
  name: 'w-checkbox',
  props: {
    uncheckvalue: {
      type: String
    },
    showError: {
      type: Boolean,
      default: true
    }
  },
  mixins: [modelMixin, titleMixin],
  components: {WError, WTooltip},
  data() {
    return {
      sid: Math.round(Math.random() * 1000000)
    };
  },
  computed: {
    unvalue() {
      if (this.uncheckvalue === undefined) {
        if (this.value === 'true') {
          return 'false';
        } else if (this.value === 'on') {
          return 'off';
        } else {
          return false;
        }
      } else {
        return this.uncheckvalue;
      }
    },
    checked() {
      // let vv = this.$model.$value;
      if (this.$options.hasFocus) {
        return this.$options.localValue;
      }
      switch (this.model.$schema.type) {
        case 'boolean':
          return this.model.$value === 'true';
        case 'array':
          return this.model.$value.indexOf(this.value) > -1;
        default:
          return this.model.$value === this.value;
      }
    }
  },
  mounted() {
    // console.log('checkbox value', JSON.stringify(this.value));
    // console.log('disabled: ', this.disabled);
  },
  methods: {
    onFocus(evt) {
      this.$options.hasFocus = true;
      this.$emit('focus');
      this.model.$hasFocus = true;
    },
    onBlur(evt) {
      this.$options.hasFocus = false;
      this.$emit('blur');
      this.model.$hasFocus = false;
    },
    onInput(evt) {
      this.$options.localValue = evt.target.checked;
      if (evt.target.checked) {
        switch (this.model.$schema.type) {
          case 'boolean':
            this.model.$value = 'true';
            break;
          case 'string':
            this.model.$value = this.value;
            break;
          case 'array':
            const pos = this.model.$value.indexOf(this.$props.value);
            if (pos === -1) {
              this.model.$addRow(this.$props.value);
            }
            break;
        }
      } else {
        switch (this.model.$schema.type) {
          case 'boolean':
            this.model.$value = 'false';
            break;
          case 'string':
            this.model.$value = this.unvalue;
            break;
          case 'array':
            const pos = this.model.$value.indexOf(this.$props.value);
            if (pos > -1) {
              this.model.$removeRow(pos);
            }
            break;
        }
      }
      this.$emit('input');
      this.fieldChanged();
    }
  }
};
</script>
